module.exports = __webpack_public_path__ + "static/api_bg@2x-1260b4da18c3dcab4c4341899608bc99.png";